import { useTags } from '@entities/common';
import { useSaveData } from '@entities/common/savedData';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowShortRight } from '@shared/assets';
import { scrollFast } from '@shared/helpers';
import { IconButton } from '@shared/ui';
import type { Author } from '@src/library/models/events';
import * as st from './styles.module.scss';

export interface CacheData {
  scrollY: number;
}

interface Props {
  author: Author;
}

export const Organizer: React.FC<Props> = ({ author }) => {
  const { tags } = useTags();
  const {
    data: cacheData,
    doSetStorageData,
    doRemoveStorageData,
  } = useSaveData<CacheData>('prevScrollData');

  useEffect(() => {
    const scrollY = cacheData?.scrollY || 0;
    if (scrollY > 0) {
      scrollFast(scrollY);
      doRemoveStorageData();
    }
  }, [cacheData]);

  const getVerbTagName = (tagId: number) => {
    const tag = tags.find((tag) => tag.id === tagId);
    if (tag?.title) {
      return tag.title;
    }
    return '';
  };

  const handleClickArrow = () => {
    doSetStorageData({
      scrollY: window.scrollY,
    });
  };

  return (
    <>
      <section className={st.card}>
        <div className={st.wrapper}>
          <div className={st.image}>{author.photo && <img src={author.photo} alt="" />}</div>
          <div className={st.content}>
            <div className={st.title}>
              {`${author?.last_name}  ${author?.first_name} ${author?.middle_name ?? ''}`}
            </div>
            {author.coach.tags.length && (
              <ul className={st.specializations}>
                {author.coach.tags.map((id) => (
                  <li key={id}>{getVerbTagName(id)}</li>
                ))}
              </ul>
            )}
          </div>
        </div>
        <Link to={`specialist/${author.coach.id}`} className={st.arrow} onClick={handleClickArrow}>
          <IconButton variant="dark">
            <ArrowShortRight />
          </IconButton>
        </Link>
      </section>
    </>
  );
};
